module.exports = __webpack_public_path__ + "img/icon_material_kczl.0014dfdf.webp";